import { Component, inject, OnInit } from '@angular/core';
import { NgIf, NgOptimizedImage } from '@angular/common';
import { LANGS } from '../../shared/constants/lang.constants';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';
import { AuthService } from '../../shared/services/auth.service';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { MatDivider } from '@angular/material/divider';
import { ID_LOGIN_TYPE } from '../../shared/constants/common.constants';
import { SharedStorageService } from '../../shared/services/shared-storage.service';
import { STORAGE_KEY } from '../../shared/constants/store-key.constants';
import { SingleActionDialogComponent } from '../../shared/components/dialogs/single-action-dialog/single-action-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { MemberInfoResponse, ModifyInfoService } from '../../shared/services/modify-info.service';
import { HomeRouterDialogComponent } from '../../shared/components/dialogs/home-router-dialog/home-router-dialog';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { companyNoValidator } from '../../shared/utils/validator.util';
import { CompanyCodeOnlyDirective } from '../../directives/company-code-only.directive';
import { VerifyEnterpriseService } from '../../shared/services/verify-enterprise.service';

/**
 * 首頁組件
 */
@Component({
  selector: 'app-new-homePage',
  standalone: true,
  imports: [NgIf, TranslatePipe, MatButton, MatDivider, NgOptimizedImage, ReactiveFormsModule, CompanyCodeOnlyDirective],
  templateUrl: './new-homePage.component.html',
  styleUrl: './new-homePage.component.scss',
})
export class NewHomePageComponent implements OnInit {
  protected readonly LANGS = LANGS;
  translateService: TranslateService = inject(TranslateService);
  authService: AuthService = inject(AuthService);
  sharedStorageService: SharedStorageService = inject(SharedStorageService);
  router: Router = inject(Router);
  route: ActivatedRoute = inject(ActivatedRoute);
  modifyInfoService: ModifyInfoService = inject(ModifyInfoService);
  verifyEnterpriseService: VerifyEnterpriseService = inject(VerifyEnterpriseService);

  showAnimation: boolean = 
    this.sharedStorageService.get('homeShowAnimation') ?? true; // 是否展示landing page
  showTitleBlockAnimation: boolean =
    this.sharedStorageService.get('homeShowAnimation') ?? true; // 是否展示title block動畫
  showPageContent: boolean = true;

  // 回到頂部按鈕是否被點擊
  isBackToTopClicked = false;

  // 回到頂部按鈕是否被滑過
  isHovered = false;

  // 預防多次點擊
  isButtonDisabled = false;

  //用來擋有沒有預約過
  flowCode: string = this.sharedStorageService.get('myReservation')?.flowCode ?? '';
  bookStatus: string = this.sharedStorageService.get('myReservation')?.bookStatus ?? '';
  dialog: MatDialog = inject(MatDialog);
  private isFormSubmitted = false;
  enterpriseCodeControl = new FormControl('', [
    Validators.required,
    (control: FormControl) => companyNoValidator(control, this.translateService)
  ]);

  // 檢查是否為 UAT 環境
  isUatEnvironment: boolean = true;

  ngOnInit() {
    console.log('Router URL:', this.router.url);

    // 若是走漸進式登入，則自動填入企業代碼
    const savedCompanyNo = this.sharedStorageService.get('companyNo');
    if (savedCompanyNo) {
      this.enterpriseCodeControl.setValue(savedCompanyNo);
    }
    
    // 檢查是否有 landing_page 參數
    this.route.queryParams.subscribe(params => {
      console.log('Query params:', params);
      if (params['landing_page'] !== undefined) {
        // 彈窗邏輯
        if (this.showAnimation) {
          setTimeout(() => {
            const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
              disableClose: true,
              data: {
                showCloseButton: true,
                closeAction: () => {
                  dialogRef.close();
                  this.router.navigate(['/healthcheck']).then();
                },
                action: () => {
                  dialogRef.close();
                  this.router.navigate(['/healthcheck']).then();
                },
              },
            });
          }, 2400);
        } else {
          const dialogRef = this.dialog.open(HomeRouterDialogComponent, {
            disableClose: true,
            data: {
              showCloseButton: true,
              closeAction: () => {
                dialogRef.close();
                this.router.navigate(['/healthcheck']).then();
              },
              action: () => {
                dialogRef.close();
                this.router.navigate(['/healthcheck']).then();
              },
            },
          });
        }
      }
    });
    // 檢查環境配置
    const env = (window as any)?.env;
    // this.isUatEnvironment = env?.environment !== 'prod';


    // 解決髒資料問題，若是已登入狀態
    if (this.sharedStorageService.get('loginStatus') === 'memberLogin') {
      this.modifyInfoService.getMemberInfo().subscribe({
        next: (res: MemberInfoResponse) => {

          // 髒資料由 interceptor 處理
          if (res.statusCode === 'S0000') {
            console.log('token有效，資料保留');
          }
        }
      });
    }

    if (this.showAnimation) {
      setTimeout(() => {
        // 展示過landing page一次後不再展示
        this.sharedStorageService.set('homeShowAnimation', false);
        this.showAnimation = false;
      }, 2400);
    }
    if (this.showTitleBlockAnimation) {
      setTimeout(() => {
        this.showTitleBlockAnimation = false;
      }, 2400);
    }
  }

  reservedBlocking(router: string) {
    //已預約過的阻擋視窗(僅供個人健檢檢核使用)
    // 2026.01.07取消個人150天內不可預約的限制
    // if (this.flowCode === '5') {
    //   // 已有已完成健檢
    //   const completeExamDialog = this.dialog.open(
    //     SingleActionDialogComponent,
    //     {
    //       data: {
    //         title: this.translateService.instant(
    //           'id-login.already-complete-recently.title'
    //         ),
    //         message: this.translateService.instant(
    //           'id-login.already-complete-recently.message'
    //         ),
    //         buttonText: this.translateService.instant(
    //           'common.button.confirm'
    //         ),
    //         showCloseButton: false,
    //         action: () => {
    //           completeExamDialog.close();
    //         },
    //       },
    //     }
    //   );
    // }else 
      if(this.flowCode === '4'){
        const completeExamDialog = this.dialog.open(
        SingleActionDialogComponent,
        {
          data: {
            title: this.translateService.instant(
              'id-login.login-already-reserved-dialog.title'
            ),
            message: this.translateService.instant(
              'id-login.login-already-reserved-dialog.message'
            ),
            buttonText: this.translateService.instant(
              'id-login.go-to-member-center'
            ),
            showCloseButton: true,
            closeAction: () => {
              completeExamDialog.close();
              this.router.navigate(['/']).then();
            },
            action: () => {
              completeExamDialog.close();
              this.router.navigate(['/healthcheck/member/mybooking']).then();
            },
          },
        }
      );
    }else{
      this.router.navigate([router]).then();
    }
  }

  handleEnterpriseClick() {
    // 預防多次點擊
    if (this.isButtonDisabled) {
      return;
    }
    this.isFormSubmitted = true;
    
    if (this.enterpriseCodeControl.valid) {
      // 檢查企業代碼格式
      if (this.enterpriseCodeControl.invalid) {
        this.enterpriseCodeControl.markAsTouched();
        return;
      }

      this.isButtonDisabled = true;
      // 設定預約類型為企業
      this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.ENTERPRISE);
      if (this.authService.isLogin() && this.sharedStorageService.get('loginStatus') === 'memberLogin') {
          if(this.flowCode === '4'){
            this.isButtonDisabled = false;
            const completeExamDialog = this.dialog.open(
            SingleActionDialogComponent,
            {
              data: {
                title: this.translateService.instant(
                  'id-login.login-already-reserved-dialog.title'
                ),
                message: this.translateService.instant(
                  'id-login.login-already-reserved-dialog.message'
                ),
                buttonText: this.translateService.instant(
                  'id-login.go-to-member-center'
                ),
                showCloseButton: true,
                closeAction: () => {
                  completeExamDialog.close();
                  this.router.navigate(['/']).then();
                },
                action: () => {
                  completeExamDialog.close();
                  this.router.navigate(['/healthcheck/member/mybooking']).then();
                },
              },
            }
          );
        } else {
          // 驗證企業資訊(CB-040) - 已登入
          this.verifyMemberEnterpriseInfo(this.enterpriseCodeControl.value?.trim() ?? '');
        }
      } else {
        // 驗證企業資訊(CB-040) - 未登入
        this.verifyNewEnterpriseInfo(this.enterpriseCodeControl.value?.trim() ?? '');
      }
    }
  }

  handlePersonalClick() {
    // 檢查環境配置，如果是 prod 環境則導向 not-available 頁面
    // 2026/2/2 打開prod
    // const env = (window as any)?.env;
    // if (env?.environment === 'prod') {
    //   this.router.navigate(['/not-available']).then();
    //   return;
    // }

    // 標記即將進行個人健檢流程
    this.sharedStorageService.set('fromIdLogin', true);
    
    // 解決髒資料問題，若是已登入狀態
    if (this.sharedStorageService.get('loginStatus') === 'memberLogin') {
      this.modifyInfoService.getMemberInfo().subscribe({
        next: (res: MemberInfoResponse) => {

          // 髒資料由 interceptor 處理
          if (res.statusCode === 'S0000') {
            console.log('token有效，資料保留');
          }
        }
      });
    }

    // 設定預約類型為個人
    this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.PERSONAL);

    // 驗證 token 有效性
    this.authService.refreshSessions().subscribe(res => {
      console.log('refreshSessions success:', res);
      // EC6009 代表 token 過期
      if (res.statusCode === 'EC6009' || res.statusCode === 'E9028') {
        // token 過期，清除資料並重新登入
        console.log('token 過期，清除資料並重新登入');
        this.sharedStorageService.clear();
        this.sharedStorageService.remove('myReservation');
        this.authService.clearToken();
        this.router.navigate(['/healthcheck/idlogin']).then(res => {});
      } 
      else if (this.authService.isLogin() && this.sharedStorageService.get('loginStatus') === 'memberLogin'){
        this.reservedBlocking('/healthcheck/reserve/location');
      } else {
        console.log('EC6007 未登入，導向idLogin');
        this.sharedStorageService.clear();
        this.sharedStorageService.remove('myReservation');
        this.authService.clearToken();
        this.router.navigate(['/healthcheck/idlogin']).then(res => {});
      }
    },
    (error) => {
      console.error('refreshSessions error:', error);
      this.sharedStorageService.clear();
      this.sharedStorageService.remove('myReservation');
      this.authService.clearToken();
      this.router.navigate(['/healthcheck/idlogin']).then(res => {});
    });
    // if (this.authService.isLogin()) {
    //   this.reservedBlocking('/healthcheck/reserve/location');
    // } else {
    //   this.router.navigate(['/healthcheck/idlogin']).then(res => {});
    // }
  }

  handleQuickReserveClick() {
    // 設定預約類型為個人
    // 檢查環境配置，如果是 prod 環境則導向 not-available 頁面
    // 2026/2/2 打開prod
    this.sharedStorageService.set('reserveStep',  1); // 重置為步驟 1
    // const env = (window as any)?.env;
    // if (env?.environment === 'prod') {
    //   this.router.navigate(['/not-available']).then();
    //   return;
    // }
    this.sharedStorageService.set('reserveType', ID_LOGIN_TYPE.PERSONAL);
    const createMemberRequest = this.sharedStorageService.get('createMemberRequest');
    if (
      this.sharedStorageService.get(STORAGE_KEY.LOGIN_STATUS) !== 'memberLogin' &&
      !createMemberRequest?.idNo &&
      !this.authService.isLogin()
    ) {
      this.sharedStorageService.set(STORAGE_KEY.LOGIN_STATUS, 'newFriend');
    }
   this.reservedBlocking('/healthcheck/reserve/location');
    
  }

  // 只有在表單提交後才顯示錯誤
  get hasError(): boolean {
    return this.enterpriseCodeControl.invalid && this.isFormSubmitted;
  }

  // 回到頂部
  scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    this.isBackToTopClicked = true;
    this.isHovered = false;
  }

  onInputChange(event: Event) {
    const input = event.target as HTMLInputElement;
    const sanitizedValue = input.value.replace(/[^0-9-]/g, '').slice(0, 10);
    
    // 同步更新 FormControl 的值
    if (this.enterpriseCodeControl.value !== sanitizedValue) {
      this.enterpriseCodeControl.setValue(sanitizedValue, { emitEvent: false });
    }
    
    // 清除錯誤狀態
    if (this.hasError) {
      this.isFormSubmitted = false;
    }
    
    // 重新驗證
    this.enterpriseCodeControl.updateValueAndValidity();
  }

  // 驗證企業資訊 (CB-040) - 已登入
  verifyMemberEnterpriseInfo(companyNo: string) {
    console.log('開始進入企業驗證，(已登入)');
    this.verifyEnterpriseService.verifyEnterpriseInfo(companyNo).subscribe({
      next: (res) => {
        if (res.statusCode === 'S0000') {
          // 是否超過企業可預約時間
          if (res.data?.isOverBookableDate === true) {
            const overBookableDateDialog = this.dialog.open(
              SingleActionDialogComponent,
              {
                disableClose: true,
                data: {
                  title: this.translateService.instant(
                    'business-login.company-code-error.title'
                  ),
                  message: this.translateService.instant(
                    'business-login.company-code-error.message'
                  ),
                  buttonText: this.translateService.instant(
                    'common.button.i-understood'
                  ),
                  showCloseButton: false,
                  closeAction: () => {
                    this.sharedStorageService.clear();
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                  action: () => {
                    this.sharedStorageService.clear();
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                },
              }
            );
          } else {
            this.isButtonDisabled = false;
            console.log('查詢成功');
            this.sharedStorageService.set('controlItem', res.data?.controlItem ?? 0);
            this.sharedStorageService.set('companyNo', companyNo);
            this.router.navigate(['/healthcheck/companylogin']).then();
          }
        } else {
          console.error('verifyEnterpriseInfo error:', res);
          // 查無企業資料
          if (res.statusCode === 'EL1007' || res.statusCode === 'EL1014') {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          } 
          // 企業預約已到期
          // else if (res.statusCode === 'EL1013') {
          //   this.sharedStorageService.clear();
          //   // this.openNoEnterpriseDialog();
          // } 
          // 暫定先都回傳查不到企業代碼
          else {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
        }
      },
      error: (error) => {
        console.error('verifyEnterpriseInfo error:', error);
        const errorDialog = this.dialog.open(
          SingleActionDialogComponent,
          {
            disableClose: true,
            data: {
              title: this.translateService.instant('error.system-error'),
              buttonText: this.translateService.instant(
                'common.button.confirm'
              ),
              showCloseButton: true,
              closeAction: () => {
                this.sharedStorageService.clear();
                this.isButtonDisabled = false;
                errorDialog.close();
                return;
              },
              action: () => {
                this.sharedStorageService.clear();
                this.isButtonDisabled = false;
                errorDialog.close();
                return;
              },
            },
          }
        );
      }
    });
  }

  // 驗證企業資訊 (CB-040) - 未登入
  verifyNewEnterpriseInfo(companyNo: string) {
    console.log('開始進入企業驗證，(未登入)');
    this.verifyEnterpriseService.verifyEnterpriseInfo(companyNo).subscribe({
      next: (res) => {
        if (res.statusCode === 'S0000') {
          // 是否超過企業可預約時間
          if (res.data?.isOverBookableDate === true) {
            const overBookableDateDialog = this.dialog.open(
              SingleActionDialogComponent,
              {
                disableClose: true,
                data: {
                  title: this.translateService.instant(
                    'business-login.company-code-error.title'
                  ),
                  message: this.translateService.instant(
                    'business-login.company-code-error.message'
                  ),
                  buttonText: this.translateService.instant(
                    'common.button.i-understood'
                  ),
                  showCloseButton: false,
                  action: () => {
                    this.isButtonDisabled = false;
                    overBookableDateDialog.close();
                    return;
                  },
                },
              }
            );
          } else {
            this.isButtonDisabled = false;
            console.log('查詢成功');
            this.sharedStorageService.set('controlItem', res.data?.controlItem ?? 0);
            this.sharedStorageService.set('companyNo', companyNo);
            this.router.navigate(['/healthcheck/idlogin']).then();
          }
        } else {
          console.error('verifyEnterpriseInfo error:', res);
          // 查無企業資料
          if (res.statusCode === 'EL1007' || res.statusCode === 'EL1014') {
            console.log('查無企業資料');
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          } 
          // // 企業預約已到期
          // else if (res.statusCode === 'EL1013') {
          //   this.sharedStorageService.clear();
          //   // this.openNoEnterpriseDialog();
          // } 
          // 暫定先都回傳查不到企業代碼
          else {
            this.sharedStorageService.clear();
            this.openNoEnterpriseDialog();
          }
        }
      },
      error: (error) => {
        console.error('verifyEnterpriseInfo error:', error);
        const errorDialog = this.dialog.open(
          SingleActionDialogComponent,
          {
            disableClose: true,
            data: {
              title: this.translateService.instant('error.system-error'),
              buttonText: this.translateService.instant(
                'common.button.confirm'
              ),
              showCloseButton: true,
              closeAction: () => {
                this.isButtonDisabled = false;
                this.sharedStorageService.clear();
                errorDialog.close();
                return;
              },
              action: () => {
                this.isButtonDisabled = false;
                this.sharedStorageService.clear();
                errorDialog.close();
                return;
              },
            },
          }
        );
      }
    });
  }

  // 查無企業資料
  openNoEnterpriseDialog() {
    const noEnterpriseDialog = this.dialog.open(
      SingleActionDialogComponent,
      {
        disableClose: true,
        data: {
          title: this.translateService.instant(
            'error.company-code-error.error-title'
          ),
          message: this.translateService.instant(
            'error.company-code-error.message'
          ),
          buttonText: this.translateService.instant(
            'common.button.i-understood'
          ),
          showCloseButton: false,
          action: () => {
            this.sharedStorageService.clear();
            this.isButtonDisabled = false;
            noEnterpriseDialog.close();
            return;
          },
        },
      }
    );
  }
}
